
import { computed, defineComponent, onBeforeUpdate, PropType, ref } from "vue";
import { toResourceUrl, microWait } from "@/lib/shared";
import HorizontalListSelectFrame from "@/components/HorizontalListSelectFrame.vue";
import TemplateThumbnailSelectFrame from "@/components/TemplateThumbnailSelectFrame.vue";
import { ITemplateSet, twoBytwoOrder } from "../services/Models";

export default defineComponent({
  name: "EditSelectFrame",
  components: {
    HorizontalListSelectFrame,
    TemplateThumbnailSelectFrame,
  },
  props: {
    isShowModal: { type: Boolean },
    templates: { type: Object as PropType<ITemplateSet[]> },
  },
  setup(props, context) {
    const isShowModalInner = computed({
      get: () => props.isShowModal,
      set: (newValue) => {
        context.emit("update:isShowModal", newValue);
      },
    });

    const currentTemplate = ref<ITemplateSet>();
    const currentFrame = ref(0);
    const inPageTemplateList = ref<ITemplateSet[]>();
    const templateSet = computed(() => {
      return props.templates;
    });
    const emptyTemplate: ITemplateSet = {
      id: -1,
      describe: "",
      frames: [],
      thumbnail: "",
      tags: [],
      deleteFlg: false
    };
    onBeforeUpdate(() => {
      if (props.templates == undefined) return;
      currentTemplate.value = props.templates[0];
      currentFrame.value = 0;
      setFrameBorderLine(currentFrame.value);
    });
    // テンプレート選択時
    const selectTemplate = (id: number) => {
      currentTemplate.value = props.templates?.find((f) => f.id == id);
      currentFrame.value = 0;
      setTemplateBorderLine();
      selectFrame(currentFrame.value);
    };
    // コマ選択時
    const selectFrame = async (order: number) => {
      await setFrameBorderLine(order);
      currentFrame.value = order;
    };
    // 確定時
    const decision = () => {
      context.emit("done", currentTemplate.value?.id, currentFrame.value);
    };
    // コマ画像のフレーム描画処理
    const setFrameBorderLine = async (order: number) => {
      await microWait();
      var className = ["rt", "rb", "lt", "lb"];
      var oldElem = document.getElementsByClassName(
        className[currentFrame.value]
      );
      var newElem = document.getElementsByClassName(className[order]);
      if (oldElem.length > 0 && newElem.length > 0) {
        if (oldElem[0].classList.contains("border")) {
          oldElem[0].classList.remove("border");
        }
        newElem[0].classList.add("border");
      }
    };
    // テンプレート一覧更新検出時処理
    const updateTemplateList = (inPageItems: ITemplateSet[]) => {
      inPageTemplateList.value = inPageItems;
      setTemplateBorderLine();
    };
    // テンプレート画像のフレーム描画処理
    const setTemplateBorderLine = async () => {
      if (inPageTemplateList.value == undefined) return;
      await microWait();
      // 選択中のテンプレートが含まれる場合は赤枠を表示する
      var index = inPageTemplateList.value.findIndex(
        (f) => f.id == currentTemplate.value?.id
      );
      var thunbnailCnt =
        document.getElementsByClassName("thunbnail-img").length;
      for (var i = 0; i < thunbnailCnt; i++) {
        var thubElem = document.getElementsByClassName("thunbnail-img")[
          i
        ] as HTMLElement;
        if (index == i) {
          thubElem.style.boxShadow = "0 0 0 5px red";
        } else {
          thubElem.style.boxShadow = "";
        }
      }
    };

    return {
      isShowModalInner,
      selectFrame,
      selectTemplate,
      decision,
      twoBytwoOrder,
      toResourceUrl,
      updateTemplateList,
      templateSet,
      currentTemplate,
      emptyTemplate,
    };
  },
});
